import {Menu, MenuGroup, MenuItem, WindowsMono} from '@blesk-frontend/ui';
import {Chrome, File} from 'lucide-react';

interface GuideCreateMenuProps {
  onCreateManual: () => void;
  onRecordExtension: () => void;
  onRecordWindows: () => void;
}

export const GuideCreateMenu = ({
  onCreateManual,
  onRecordExtension,
  onRecordWindows,
}: GuideCreateMenuProps) => {
  return (
    <Menu>
      <MenuGroup>
        <MenuItem icon={Chrome} onClick={onRecordExtension}>
          Записать для сайта
        </MenuItem>
        <MenuItem icon={WindowsMono} onClick={onRecordWindows}>
          Записать для приложения
        </MenuItem>
      </MenuGroup>

      <MenuGroup>
        <MenuItem icon={File} onClick={onCreateManual}>
          Создать вручную
        </MenuItem>
      </MenuGroup>
    </Menu>
  );
};
